// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\SessionEngineEventResponse

import { OfferEngineType, SessionEngineEventLocationOverrideMode } from './enums.gen';
import { hydrateSessionEngineEventDate, type SessionEngineEventDate, type SessionEngineEventDateApiResponse } from './sessionEngineEventDate.gen';

export type SessionEngineEventApiResponse = {
	type: OfferEngineType.Event;
	totalEventCapacity: number | null;
	dates: SessionEngineEventDateApiResponse[];
	locationOverrideMode: SessionEngineEventLocationOverrideMode;
	customLocation: string | null;
	customLocationExtra: string | null;
};

export type SessionEngineEvent = {
	type: OfferEngineType.Event;
	totalEventCapacity: number | null;
	dates: SessionEngineEventDate[];
	locationOverrideMode: SessionEngineEventLocationOverrideMode;
	customLocation: string | null;
	customLocationExtra: string | null;
};

export function hydrateSessionEngineEvent(data: SessionEngineEventApiResponse): SessionEngineEvent {
	return {
		...data,
		dates: data.dates.map(hydrateSessionEngineEventDate),
	};
}